import Modal from 'react-modal';

import { navigateTo, getSettings, getCurvesList, getPatientDetails,editUserClinic, setSettings, setDiagnosis, setNewPass, clearSelectedPatient,setSelectedUser, requestResetPasswrod } from '../../redux/actions'
import { getUserDetails} from '../../redux/actions/UserAction'
import ThoracicDegreeTables from '../common/thoracic-degree-tables';
import AdminLayout from './admin/AdminLayout'
import BackToPage from '../common/back-to-page'
import { colors, patientDetailsStyles } from '../../theme/style';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Header, Loading } from '../common';
import Compliance from '../common/compliance';
import Cookies from 'js-cookie'
import image1 from '../../assets/images/1.jpg'
import image2 from '../../assets/images/2.jpg'
import { Link } from 'react-router-dom';
import { convertToRoleStrings, fromRoleNumToString, getUserFromToken, getUserRoles, isAdminClinic, isLoggedInis, isUserClinic, parseJwt, statusTypes } from '../../utils/CFuncs';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import EditUserModal from './EditUserModal';
import { roles, urls } from '../../utils/Objects';
  
import { setError,setSuccess } from '../../redux/actions/MessageAction';
import Alerts from '../common/Alerts';

class UserDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      isResetButtonEnabled: true,
    };
    this.updateState = this.updateState.bind(this)
    this.updateIsResetButtonEnabled= this.updateIsResetButtonEnabled.bind(this)
  

  }

  componentDidMount() {
    console.log('componentDidMount userDetails');
    console.log('this.props.selectedUser')
    let userId 
    
     userId = (isUserClinic() || isAdminClinic() )?  getUserFromToken().uid: this.props.userId;
    
    this.props.getUserDetails(userId)

  }
  
  
  componentDidUpdate(prevProps, nextProps) {
    if(JSON.stringify(prevProps.selectedUser) === JSON.stringify(nextProps.selectedUser)){
      this.setState({user:nextProps.selectedUser})

    }
  }
  componentWillUnmount() {
    console.log('componentWillUnmount userDetails')
    this.props.setSuccess("")
    this.props.setError("")
   
  }

  updateState(user){
    this.setState({user,showModal:false})
  }
  updateUser = (user,roleAction) => {
    console.log("updateUser");      
    console.log(user);
    
    this.props.editUserClinic(user,roleAction,this.updateState);
  };



  openModal = () => {
    this.props.setError("");
    this.setState({ showModal: true });
  };
  closeModal = () => {
    this.setState({ showModal: false });
  };
  
  hasAccessToReset = () => {
    const token = Cookies.get("auth")
    const user = parseJwt(token)
    const isAdmin = user.roles === roles.Administrator
    return isAdmin
  }
  updateIsResetButtonEnabled = () => {
    this.setState({ isResetButtonEnabled: true });
  }
  
  resetPassword = () => {
    if(!this.state.isResetButtonEnabled) { 
      return
    }
    this.props.requestResetPasswrod(this.props.selectedUser.email,this.updateIsResetButtonEnabled,this.updateIsResetButtonEnabled);
    this.setState({ isResetButtonEnabled: false });
  }
  hasPermission = () => {
    console.log('hasPermission')
    const user = getUserFromToken()
    const isLoggedUser = user.uid == this.props.selectedUser?.id
    return (isAdminClinic() ||  isLoggedInis(roles.Administrator)) && !isLoggedUser
  }

  
  render() {
    
    const user = this.props.selectedUser
    console.log('render user details');
    console.log(user);
    // console.log(this.props.user.selectedUser);





    console.log("user details render" + user?.roles)
        // const {firstName,lastName,email,roleID,id} = this.props.location.state
  

        return (<AdminLayout {...this.props}>
    <Alerts />
          <section style={patientDetailsStyles.container}>
            <div navstyle={patientDetailsStyles.navstyle}>
                    <BackToPage link={urls.users} text="User List" />
                <div>
           
                {user && user.roles && <EditUserModal
                  closeModal={this.closeModal}
                  showModal={this.state.showModal}
                  handleClick={this.updateUser}
                  title="Edit User"
                  currentUser={user}
              /> }
              

              <div style={patientDetailsStyles.title}> My Details</div>
              
              <div>
                  <label>First Name:</label>
                  <span>{" "+user?.firstName}</span>
                </div>
         
                
                <div>
                  <label>Last Name:</label>
                  <span>{" "+user?.lastName}</span>
                </div>

                <div>
                  <label>Email :</label>
                  <span>{" "+user?.email}</span>
                </div>
         
                <div>
                  <label>Role : </label>
                  <span>{user?.roleID === 0? "Admin" : "User"}</span>
                </div>
                <div>
                  <label>roles Enitities : </label>
                  {/* {user?.roles && <span>{user?.roles.join(" ,")}</span>} */}
                  {user && user.roles && <span>{convertToRoleStrings(user?.roles).join(" ,")}</span>}
                </div>
                </div>

           
              {this.hasPermission() && (
                <button style={styles.buttonGreen} onClick={() => this.openModal()}>
                    edit user
                  </button>
               )}

          </div>

            {this.hasAccessToReset() && (
              <div>

              <button style={this.state.isResetButtonEnabled ? styles.buttonRed : styles.buttonGray} onClick={this.resetPassword}>
                  reset password
                </button>
              </div>

                )}



            </section>

        </AdminLayout>)



  }
}

const button = {
  cursor: "pointer",
  border: "none",
  color: "white",
  padding: 7,
  textAlign: "center",
  textDecoration: "none",
  display: "inline-block",
  fontSize: 16,
  userSelect: "none",
}

const styles = {
  medContainer: {
    padding: "1rem",
    position: "relative",
    // border: '1px solid',
    width: "70vw",
    display: "flex",
    justifyContent: "space-between",
  },
  button,
  buttonGreen: {
    ...button,
    backgroundColor: "#4CAF50",
  } ,
  buttonRed: {
    ...button,
    marginTop: "5rem",
    backgroundColor: "#ea0404",
  } ,
  buttonGray: {
    ...button,
    marginTop: "5rem",
    backgroundColor: "#605959",
  } ,
  error: {
    color: "#ea0404",
  },
  success: {
    color: "#4CAF50",
  },

  container:{
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    // border: '1px solid'
  },


}

const mapStateToProps = (state, ownProps) => {
  // const user = ownProps.location?.state?.user
  const userId = ownProps.location?.state?.userId
  // const user = ownProps.location.state.user
  return (
    {
      login: state.login,
      user: state.user,
      message: state.message,
      selectedUser: state.user.selectedUser ,
      userId
      // selectedUser:   ownProps.location.state.item ?? state.user.selectedUser ,
      
      
    }
  )
}

const mapDispatchToProps = {

  navigateTo,
  getCurvesList,
  getSettings,
  getPatientDetails,
  setSettings,
  setDiagnosis,
  setNewPass,
  clearSelectedPatient,
  setError,
  editUserClinic,
  setSelectedUser,
  setSuccess,
  getUserDetails,
  requestResetPasswrod
  
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails)